import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '@services/api.service'
import {AudioModel, audioUrl} from '@editor/store/slices/audio.slice'
import { AxiosError } from 'axios'

export const generateTmpAudio = createAsyncThunk(
  'audio/downloadAudio',
  async (smallSsml: string, { rejectWithValue }) => {
    try {
      const response = await api.post(`/${audioUrl}/generate/`, {
        ssml: smallSsml,
        temp: 'true',
      })
      return response.data.data
    } catch (error: any) {
      if (error instanceof AxiosError && error?.response?.data?.message) {
        return rejectWithValue(error?.response?.data?.message)
      }
      return rejectWithValue('Došlo k nečekáné chybě')
    }
  }
)

interface UploadAudioPayload {
  name: string
  file: File
}

export const uploadAudio = createAsyncThunk(
  'audio/uploadAudio',
  async ({ name, file }: UploadAudioPayload, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/${audioUrl}/upload/`,
        {
          audioName: name,
          audioFile: file,
        },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )

      const audio = await response.data.data as AudioModel
      return audio
    } catch (error: any) {
      if (error instanceof AxiosError && error?.response?.data?.message) {
        return rejectWithValue(error?.response?.data?.message)
      }
      return rejectWithValue('Došlo k nečekáné chybě')
    }
  }
)
